module.exports = __webpack_public_path__ + "img/24.7eaf5054.jpg";